export const PAGE_TITLE = 'Rental Applications | Zillow';
export const PAGE_DATA_ERROR = 'There was an error getting data about applicants';
export const ICRAA_FAILED_MISSING_NAME = 'Unable to send ICRAA acceptance to Finicity. No name value found for Irene.';
